import { Link } from 'react-router-dom';

export default function Community() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
      <div className="relative overflow-hidden rounded-2xl bg-accent-500 px-6 py-12 text-center md:px-12 md:py-16">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20abstract%20pattern%20of%20connected%20speech%20bubbles%20and%20fans%20icons%20floating%20in%20a%20teal%20green%20space%2C%20soft%20warm%20glow%2C%20community%20vibe%2C%20clean%20modern%20graphic%2C%20no%20text&width=1400&height=500&seq=community-bg-2026&orientation=landscape"
          alt="漫画追更社区"
          className="absolute inset-0 h-full w-full object-cover opacity-20"
        />
        <div className="relative z-10 mx-auto flex max-w-2xl flex-col items-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/20 px-4 py-1.5 text-sm font-medium text-background-50 backdrop-blur">
            <i className="ri-chat-heart-fill" /> 漫画追更社区
          </span>
          <h2 className="mt-4 font-heading text-3xl text-background-50 md:text-4xl">追更路上，不孤单</h2>
          <p className="mt-3 text-sm leading-relaxed text-background-100 md:text-base">
            和百万追更党一起交流剧情、分享心得、安利新作。加入社区，发现更多和你口味相同的同好。
          </p>
          <div className="mt-6 flex flex-col gap-3 sm:flex-row">
            <Link
              to="/about"
              className="whitespace-nowrap rounded-full bg-background-50 px-6 py-3 text-sm font-semibold text-accent-700 transition-colors hover:bg-background-100"
            >
              了解更多
            </Link>
            <a
              href="#articles"
              className="whitespace-nowrap rounded-full border border-background-50/40 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
            >
              浏览追更资讯
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}